export default __webpack_public_path__ + "static/media/S100.5a83c0a0.gif";